import React, { useState, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useUserContext } from "../context/user_context";

function RecaptchaComponent({ reset }) {
  const { captchaState, setCaptchaState, setSend } = useUserContext();
  const recaptchaRef = useRef(null);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     recaptchaRef.current.reset(); // Resets the reCAPTCHA
  //   }, 30000); // Refresh every 30 seconds

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [reset]);

  const handleExpire = () => {
    // console.log("handleExpire");
    setCaptchaState({ ask: true, ...captchaState });
  };

  const handleToken = (token) => {
    // console.log("handletoken", token);
    setCaptchaState({ ask: true, token: token });
    setSend(true);
  };
  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      // sitekey={process.env.REACT_APP_SITE_KEY}
      // in .env REACT_APP_SITE_KEY=6Lf-K9UbAAAAALpRAxgGlYfP1b5gGBYYcTntCEVH
      sitekey={"6Lf-K9UbAAAAALpRAxgGlYfP1b5gGBYYcTntCEVH"}
      onChange={handleToken}
      // hl="ka"
      // onExpired={handleExpire}
    />
  );
}

export default RecaptchaComponent;
